import type { AppCardData } from './types';

export type UnclaimedFooterMode = 'finish_setup' | 'awaiting_vendor' | 'read_only';

export const getUnclaimedFooterMode = (data: Pick<AppCardData, 'canManage' | 'owned'>): UnclaimedFooterMode => {
  if (!data.owned) return 'awaiting_vendor';

  return data.canManage ? 'finish_setup' : 'read_only';
};
